import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IonIcon, IonPopover } from '@ionic/angular/standalone';

@Component({
  selector: 'info-tooltip',
  standalone: true,
  imports: [IonIcon, IonPopover],
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .info-tooltip-popover {
      --width: 260px;
      --max-width: 260px;
      --overflow: hidden;
    }
    .info-tooltip-popover::part(content) {
      border-radius: 16px;
    }
    .info-tooltip-popover ion-content {
      --overflow: hidden;
    }
  `],
  template: `
    <ion-icon
      [id]="triggerId"
      name="information-circle"
      class="cursor-pointer align-middle ml-[5px] text-[20px]"
      style="color:var(--ion-color-medium-shade)"
    ></ion-icon>

    <ion-popover
      [trigger]="triggerId"
      triggerAction="click"
      [dismissOnSelect]="false"
      size="auto"
      side="top"
      alignment="start"
      class="info-tooltip-popover"
      #tooltipPopover
    >
      <ng-template>
        <div class="break-words overflow-hidden box-border rounded-[16px]">

          <!-- Header -->
          <div class="flex items-center justify-between px-[14px] pt-3 pb-[10px] border-b border-[var(--ion-border-color,#e0e0e0)]">
            <span class="text-[13px] font-semibold text-[var(--ion-text-color)]">{{ title }}</span>
            <ion-icon
              name="close-outline"
              (click)="tooltipPopover.dismiss()"
              class="cursor-pointer text-[22px] shrink-0 ml-2 mr-1 mb-[2px]"
              style="color:var(--ion-color-medium-shade)"
            ></ion-icon>
          </div>

          <!-- Body -->
          <div class="px-[14px] pt-3 pb-[14px]">
            <p class="mt-0 mb-[10px] text-[13px] leading-relaxed break-words whitespace-normal text-[var(--ion-text-color)]">
              {{ message }}
            </p>
            @if (example) {
              <div class="flex items-center gap-[2px] flex-wrap">
                <span class="text-[11px] font-semibold uppercase tracking-[0.5px] text-[var(--ion-text-color)]">e.g. :</span>
                <code class="text-[12px] px-2 py-[3px] rounded font-semibold break-all bg-[var(--ion-color-light)] text-[var(--ion-text-color)]">{{ example }}</code>
              </div>
            }
          </div>

        </div>
      </ng-template>
    </ion-popover>
  `,
})
export class InfoTooltipComponent {
  @Input() triggerId!: string;
  @Input() title: string = 'Info';
  @Input() message: string = '';
  @Input() example?: string;
}
